/**
 * DevExtreme (esm/__internal/ui/popover/m_popover.full.js)
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import "../../../ui/toolbar";
import registerComponent from "../../../core/component_registrator";
import Popover from "../../../ui/popover/ui.popover";
let PopoverFull = /*#__PURE__*/(() => {
  class PopoverFull extends Popover {
    _getDefaultOptions() {
      return _extends({}, super._getDefaultOptions(), {
        preventScrollEvents: false
      });
    }
    _getToolbarName() {
      return "dxToolbar";
    }
  }
  PopoverFull.defaultOptions = function (rule) {
    Popover.defaultOptions(rule);
  };
  return PopoverFull;
})();
export { PopoverFull as default };
registerComponent("dxPopover", PopoverFull);